module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAVCAMAAAB8FU7dAAAAe1BMVEX////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////QYBnOAAAAKHRSTlMAAQIJCw8SFBUYGzdgZm5weHygpqerrLC5wMTJzs/Q0+Xp7fDx8/z+I6xRSwAAAGxJREFUGNO9yscOgCAQRdGxV+y9gQ35/y9UJCaiSxPv6s3JAIjsaTRAysaUtqYsS9es2LpRMHt16S3oRqoGdQm6Ii6U8CJO8TkRbGQ4yjjlfJENWCi+DzoL2V9UFS9ynRddfaLUl0oZ9OxRvwMn/A/qeZ03awAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/groups/group_icon_share_score.png
// module id = 698
// module chunks = 0